import React from "react";

import { StyledMarkContainer, StyledRecommendation, StyledRecommendationContainer, StyledRecommender } from "./recommendation.style";
import mark from "../../../img/mark.svg";
import { getRecommender } from "./recommendationList";

const Recommendation = (props) => {
	const imgStyle = { width: "45px", height: "45px", border: "2.46479px solid #F1F1F1", borderRadius: "49.8826px", filter: "grayscale(1)", objectFit: "cover", padding: "0 " };
	const theme = props.theme || "box";
	const recommender = getRecommender();

	return (
		<StyledRecommendationContainer theme={theme}>
			<StyledMarkContainer theme={theme}>
				<img src={mark} alt="" style={{ transform: "translateY(5px)" }} />
				<img src={mark} alt="" style={{ transform: "translateY(5px)" }} />
			</StyledMarkContainer>
			<StyledRecommendation>"{recommender.recommendation}"</StyledRecommendation>

			<StyledRecommender theme={theme}>
				<img src={recommender.img} alt={"recommender"} style={imgStyle} />
				<div>
					<h4> {recommender.name}</h4>
					<p> {recommender.position}</p>
				</div>
			</StyledRecommender>
		</StyledRecommendationContainer>
	);
};

export default React.memo(Recommendation);
